import {bootstrapRecommenderType} from '../../modules-optimized/carousel/pdp-recommender-native';
bootstrapRecommenderType('crossed-products');
